/**
 * Error Handler HOC compoment 
 * Example:
 * export const HomeComponent = ErrorHandler(Home);
*/
import React from 'react';
import ErrorHandlerWrapper from './errorHandler';

export const ErrorHandler = (Child) => (props) => (
  <ErrorHandlerWrapper>
    <Child {...props} />
  </ErrorHandlerWrapper>
);
